var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-header" },
      [
        !_vm.saved
          ? [_vm._v(" " + _vm._s(_vm.T.runDetailsNewFeedback) + " ")]
          : [
              _c("omegaup-user-username", {
                attrs: {
                  classname: _vm.feedback.authorClassname,
                  username: _vm.feedback.author,
                  linkify: true,
                },
              }),
              _vm._v(" " + _vm._s(_vm.currentFeedbackTimestamp) + " "),
            ],
        _vm.currentFeedback.status === _vm.FeedbackStatus.InProgress
          ? _c(
              "button",
              {
                staticClass: "close btn-sm",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onDeleteFeedback.apply(null, arguments)
                  },
                },
              },
              [_vm._v(" ❌ ")]
            )
          : _vm._e(),
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "card-body" },
      [
        !_vm.saved
          ? _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentFeedback.text,
                  expression: "currentFeedback.text",
                },
              ],
              ref: "feedback-form",
              staticClass: "w-100",
              attrs: { placeholder: _vm.T.runDetailsFeedbackPlaceholder },
              domProps: { value: _vm.currentFeedback.text },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.currentFeedback, "text", $event.target.value)
                },
              },
            })
          : _c("omegaup-markdown", {
              attrs: { markdown: _vm.currentFeedback.text, "full-width": true },
            }),
      ],
      1
    ),
    !_vm.saved
      ? _c("div", { staticClass: "card-footer text-muted" }, [
          _c("div", { staticClass: "form-group my-2" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary mx-2",
                attrs: {
                  "data-button-submit": "",
                  disabled: !_vm.currentFeedback.text,
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onSubmitFeedback.apply(null, arguments)
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.T.runDetailsFeedbackAddReview) + " ")]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-danger mx-2",
                attrs: { "data-button-cancel": "" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onCancelFeedback.apply(null, arguments)
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.T.runDetailsFeedbackCancel) + " ")]
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }